export const mockResdata = {
  success: "True",
  data: {
    t1: "None",
    t2: [
      {
        bm1: [
          {
            mid: "1.193106671",
            mname: "Bookmaker",
            remark: "West Indiess vs Ireland Match Bet Started In Our Exchange",
            remark1: "",
            min: "100.00",
            max: "500000.00",
            sid: "1",
            nat: "South Africa",
            b1: "88.00",
            bs1: "500000.00",
            l1: "93.00",
            ls1: "500000.00",
            s: "ACTIVE",
            sr: "1",
            gtype: "Match1",
            utime: "0",
            b2: "0.00",
            bs2: "0.00",
            b3: "0.00",
            bs3: "0.00",
            l2: "0.00",
            ls2: "0.00",
            l3: "0.00",
            ls3: "0.00",
            b1s: "True",
            b2s: "False",
            b3s: "False",
            l1s: "True",
            l2s: "False",
            l3s: "False",
          },
          {
            mid: "1.193106671",
            mname: "Bookmaker",
            remark: "West Indiess vs Ireland Match Bet Started In Our Exchange",
            remark1: "",
            min: "100.00",
            max: "500000.00",
            sid: "2",
            nat: "India",
            b1: "0.00",
            bs1: "0.00",
            l1: "0.00",
            ls1: "0.00",
            s: "SUSPENDED",
            sr: "2",
            gtype: "Match1",
            utime: "0",
            b2: "0.00",
            bs2: "0.00",
            b3: "0.00",
            bs3: "0.00",
            l2: "0.00",
            ls2: "0.00",
            l3: "0.00",
            ls3: "0.00",
            b1s: "False",
            b2s: "False",
            b3s: "False",
            l1s: "False",
            l2s: "False",
            l3s: "False",
          },
          {
            mid: "1.193106671",
            mname: "Bookmaker",
            remark: "West Indiess vsIreland Match Bet Started In Our Exchange",
            remark1: "",
            min: "100.00",
            max: "500000.00",
            sid: "3",
            nat: "The Draw",
            b1: "0.00",
            bs1: "0.00",
            l1: "0.00",
            ls1: "0.00",
            s: "ACTIVE",
            sr: "3",
            gtype: "Match1",
            utime: "0",
            b2: "0.00",
            bs2: "0.00",
            b3: "0.00",
            bs3: "0.00",
            l2: "0.00",
            ls2: "0.00",
            l3: "0.00",
            ls3: "0.00",
            b1s: "True",
            b2s: "False",
            b3s: "False",
            l1s: "True",
            l2s: "False",
            l3s: "False",
          },
        ],
        bm2: [],
      },
    ],
    t3: [
      {
        mid: "1.193106671",
        sid: "544",
        nat: "Only 3 over run SA2",
        b1: "3.00",
        bs1: "100.00",
        l1: "2.00",
        ls1: "100.00",
        b2: "0.00",
        bs2: "0.00",
        l2: "0.00",
        ls2: "0.00",
        b3: "0.00",
        bs3: "0.00",
        l3: "0.00",
        ls3: "0.00",
        gtype: "Fancy",
        utime: "0",
        gvalid: "0",
        gstatus: "",
        remark: "",
        min: "100.00",
        max: "25000.00",
        srno: "1",
        s1: "0",
        s2: "0",
        ballsess: "2",
      },
      {
        mid: "1.19310667122",
        sid: "552",
        nat: "Fall of 1st wkt SA 2",
        b1: "26.00",
        bs1: "100.00",
        l1: "26.00",
        ls1: "120.00",
        b2: "0.00",
        bs2: "0.00",
        l2: "0.00",
        ls2: "0.00",
        b3: "0.00",
        bs3: "0.00",
        l3: "0.00",
        ls3: "0.00",
        gtype: "Fancy",
        utime: "0",
        gvalid: "0",
        gstatus: "",
        remark: "",
        min: "100.00",
        max: "200000.00",
        srno: "5",
        s1: "0",
        s2: "0",
        ballsess: "1",
      },
      {
        mid: "1.193101",
        sid: "535",
        nat: "10 over run SA 2",
        b1: "28.00",
        bs1: "100.00",
        l1: "26.00",
        ls1: "100.00",
        b2: "0.00",
        bs2: "0.00",
        l2: "0.00",
        ls2: "0.00",
        b3: "0.00",
        bs3: "0.00",
        l3: "0.00",
        ls3: "0.00",
        gtype: "Fancy",
        utime: "0",
        gvalid: "0",
        gstatus: "",
        remark: "",
        min: "100.00",
        max: "50000.00",
        srno: "2",
        s1: "0",
        s2: "0",
        ballsess: "1",
      },
      {
        mid: "1.1936671",
        sid: "537",
        nat: "2 over run SA 2",
        b1: "6.00",
        bs1: "400.00",
        l1: "6.00",
        ls1: "600.00",
        b2: "0.00",
        bs2: "0.00",
        l2: "0.00",
        ls2: "0.00",
        b3: "0.00",
        bs3: "0.00",
        l3: "0.00",
        ls3: "0.00",
        gtype: "Fancy",
        utime: "0",
        gvalid: "0",
        gstatus: "",
        remark: "",
        min: "100.00",
        max: "100000.00",
        srno: "1",
        s1: "0",
        s2: "0",
        ballsess: "1",
      },
      {
        mid: "1.1936671",
        sid: "533",
        nat: "5 over run SA 2",
        b1: "13.00",
        bs1: "85.00",
        l1: "13.00",
        ls1: "115.00",
        b2: "0.00",
        bs2: "0.00",
        l2: "0.00",
        ls2: "0.00",
        b3: "0.00",
        bs3: "0.00",
        l3: "0.00",
        ls3: "0.00",
        gtype: "Fancy",
        utime: "0",
        gvalid: "0",
        gstatus: "",
        remark: "",
        min: "100.00",
        max: "100000.00",
        srno: "2",
        s1: "0",
        s2: "0",
        ballsess: "1",
      },
      {
        mid: "1.3106671",
        sid: "553",
        nat: "D Elgar run 2",
        b1: "23.00",
        bs1: "90.00",
        l1: "23.00",
        ls1: "110.00",
        b2: "0.00",
        bs2: "0.00",
        l2: "0.00",
        ls2: "0.00",
        b3: "0.00",
        bs3: "0.00",
        l3: "0.00",
        ls3: "0.00",
        gtype: "Fancy",
        utime: "0",
        gvalid: "0",
        gstatus: "",
        remark: "",
        min: "100.00",
        max: "200000.00",
        srno: "6",
        s1: "0",
        s2: "0",
        ballsess: "1",
      },
      {
        mid: "1.193106671",
        sid: "532",
        nat: "3 over run SA 2",
        b1: "9.00",
        bs1: "100.00",
        l1: "8.00",
        ls1: "100.00",
        b2: "0.00",
        bs2: "0.00",
        l2: "0.00",
        ls2: "0.00",
        b3: "0.00",
        bs3: "0.00",
        l3: "0.00",
        ls3: "0.00",
        gtype: "Fancy",
        utime: "0",
        gvalid: "0",
        gstatus: "",
        remark: "",
        min: "100.00",
        max: "100000.00",
        srno: "2",
        s1: "0",
        s2: "0",
        ballsess: "1",
      },
      {
        mid: "1.193106671",
        sid: "556",
        nat: "A Markram boundaries 2",
        b1: "5.00",
        bs1: "100.00",
        l1: "4.00",
        ls1: "100.00",
        b2: "0.00",
        bs2: "0.00",
        l2: "0.00",
        ls2: "0.00",
        b3: "0.00",
        bs3: "0.00",
        l3: "0.00",
        ls3: "0.00",
        gtype: "Fancy",
        utime: "0",
        gvalid: "0",
        gstatus: "",
        remark: "",
        min: "100.00",
        max: "10000.00",
        srno: "7",
        s1: "0",
        s2: "0",
        ballsess: "1",
      },
      {
        mid: "1.193106671",
        sid: "555",
        nat: "A Markram run2",
        b1: "24.00",
        bs1: "90.00",
        l1: "24.00",
        ls1: "110.00",
        b2: "0.00",
        bs2: "0.00",
        l2: "0.00",
        ls2: "0.00",
        b3: "0.00",
        bs3: "0.00",
        l3: "0.00",
        ls3: "0.00",
        gtype: "Fancy",
        utime: "0",
        gvalid: "0",
        gstatus: "",
        remark: "",
        min: "100.00",
        max: "200000.00",
        srno: "6",
        s1: "0",
        s2: "0",
        ballsess: "1",
      },
      {
        mid: "1.193106671",
        sid: "557",
        nat: "1st wkt pship boundaries SA 2",
        b1: "5.00",
        bs1: "100.00",
        l1: "4.00",
        ls1: "100.00",
        b2: "0.00",
        bs2: "0.00",
        l2: "0.00",
        ls2: "0.00",
        b3: "0.00",
        bs3: "0.00",
        l3: "0.00",
        ls3: "0.00",
        gtype: "Fancy",
        utime: "0",
        gvalid: "0",
        gstatus: "",
        remark: "",
        min: "100.00",
        max: "10000.00",
        srno: "7",
        s1: "0",
        s2: "0",
        ballsess: "1",
      },
      {
        mid: "1.193106671",
        sid: "554",
        nat: "D Elgar boundaries 2",
        b1: "3.00",
        bs1: "85.00",
        l1: "3.00",
        ls1: "115.00",
        b2: "0.00",
        bs2: "0.00",
        l2: "0.00",
        ls2: "0.00",
        b3: "0.00",
        bs3: "0.00",
        l3: "0.00",
        ls3: "0.00",
        gtype: "Fancy",
        utime: "0",
        gvalid: "0",
        gstatus: "",
        remark: "",
        min: "100.00",
        max: "10000.00",
        srno: "7",
        s1: "0",
        s2: "0",
        ballsess: "1",
      },
    ],
    t4: "None",
  },
  status: 200,
  updatetime: "2022-01-13T13:47:46.900Z",
  eventTypeId: "4",
  eventTypeName: "cricket",
  eventName: "South Africa v India / Jan 11 2022  2:00PM (IST)",
  name: "South Africa v India",
  eventDate: "2022-01-11T14:00:00",
  gameId: "31162031",
};

const res2 = {
  bookmake: [
    {
      runners: [
        {
          SelectionId: 7021,
          RunnerName: "South Africa",
          LayPrice1: 1,
          LaySize1: 100,
          LayPrice2: "0",
          LaySize2: "0",
          LayPrice3: "0",
          LaySize3: "0",
          BackPrice1: "0",
          BackSize1: 100,
          BackPrice2: "0",
          BackSize2: "0",
          BackPrice3: "0",
          BackSize3: "0",
          GameStatus: "SUSPEND",
        },
        {
          SelectionId: 2464,
          RunnerName: "Pakistan",
          LayPrice1: 0,
          LaySize1: 100,
          LayPrice2: "0",
          LaySize2: "0",
          LayPrice3: "0",
          LaySize3: "0",
          BackPrice1: 0,
          BackSize1: 100,
          BackPrice2: "0",
          BackSize2: "0",
          BackPrice3: "0",
          BackSize3: "0",
          GameStatus: "SUSPEND",
        },
      ],
    },
  ],
  session: [
    {
      SelectionId: "4.1757428059-F3",
      RunnerName: "Lunch Fav Odds (SA vs PAK) Adv",
      LaySize1: 0,
      LayPrice1: 0,
      BackSize1: 0,
      BackPrice1: 0,
      GameStatus: "SUSPEND",
    },
  ],
  market: [
    {
      marketId: "1.30420185",
      inplay: false,
      totalMatched: null,
      totalAvailable: null,
      priceStatus: null,
      events: [
        {
          SelectionId: "",
          RunnerName: "South Africa",
          LayPrice1: "1.01",
          LaySize1: "85.8",
          LayPrice2: "1.02",
          LaySize2: "20",
          LayPrice3: "1.03",
          LaySize3: "774.58",
          BackPrice1: "0",
          BackSize1: "0",
          BackPrice2: "0",
          BackSize2: "0",
          BackPrice3: "0",
          BackSize3: "0",
        },
        {
          SelectionId: "",
          RunnerName: "Pakistan",
          LayPrice1: "0",
          LaySize1: "0",
          LayPrice2: "0",
          LaySize2: "0",
          LayPrice3: "0",
          LaySize3: "0",
          BackPrice1: "1000",
          BackSize1: "59.92",
          BackPrice2: "500",
          BackSize2: "10",
          BackPrice3: "120",
          BackSize3: "1.92",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/HomePage/mockres.js